import React from "react";
import Charts from "../components/Charts/Charts";
import { calculateROI } from "../api";
import { GlobalContext } from "../context/GlobalContext";
import SEO from "../components/SEO/SEO";
import formatNumber from "../helpers/formatNumber";
import ToolDisclaimer from "../components/Disclaimer/ToolDisclaimer";

function ReturnOfInvestment() {
  const { isMobile } = React.useContext(GlobalContext);
  const [calculatedRoi, setCalculatedCRoi] = React.useState({});
  const [roiChartData, setRoiChartData] = React.useState([]);
  const selectedChartData = ["Wert", "Dividende"];

  //* handle form submit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    const investment = e.target[0]?.value;
    const amount = e.target[1]?.value;
    const increasePercentage = e.target[2]?.value;
    const dividendYield = e.target[3]?.value;
    const increaseDividend = e.target[4]?.value;

    try {
      const result = await calculateROI(
        investment,
        amount,
        increasePercentage,
        dividendYield,
        increaseDividend
      );
      setCalculatedCRoi(result);

      const chartData = [];
      result.details.forEach((el) => {
        chartData.push({
          name: `Jahr ${el.year}`,
          Wert: el?.investmentValue,
          Dividende: el?.cumulativeDividends,
        });
      });
      setRoiChartData(chartData);
    } catch (error) {}
  };

  return (
    <>
      <SEO
        title="Kapitalrendite"
        keywords="Kapitalrendite"
        description="Kapitalrendite"
        type="Kapitalrendite"
        url={window.location.href}
      />
      <div
        className={`${!isMobile && "article-text"} ${
          isMobile && "add-padding-20"
        } text-justify text-light`}
      >
        <h1 className="text-light article-header">Kapitalrendite</h1>
        <ToolDisclaimer />

        <br />
        <form onSubmit={handleSubmit} id="compoundInterestForm">
          <div className="form-group">
            <label className="text-light" for="formName">
              Investition
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={1000}
                min={1}
              />
              <span className="input-group-text" id="basic-addon2">
                €
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Anzahl Aktien
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                defaultValue={10}
                min={1}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Erwartete Kursänderung pro Jahr
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={0}
              />
              <span className="input-group-text" id="basic-addon2">
                %
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Dividendenrendite
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={2.5}
              />
              <span className="input-group-text" id="basic-addon2">
                %
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Dividendenwachstum
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={4.5}
              />
              <span className="input-group-text" id="basic-addon2">
                %
              </span>
            </div>
          </div>

          <div className="text-right">
            <button type="submit" className="btn btn-primary formsubmit">
              Berechnen
            </button>
          </div>
        </form>
        {calculatedRoi &&
          calculatedRoi.status === "success" &&
          Object.keys(calculatedRoi)?.length > 0 && (
            <>
              <br />
              <p>
                Bei einer angenommenen Kursänderung von
                <b className="visualizeLink linkIsInformative">
                  {` ${formatNumber(
                    calculatedRoi?.increasePercentage?.toFixed(2)
                  )}%`}
                </b>
                , einer Dividendenrendite von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedRoi?.dividendYield?.toFixed(2)
                )}% `}</b>
                und einem Dividendenwachstum von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedRoi?.increaseDividend?.toFixed(2)
                )}% `}</b>
                erhälst du deine ursprüngliche Investition von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedRoi?.investment?.toFixed(2)
                )}€ `}</b>
                nach etwa
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedRoi?.duration?.toFixed(2)
                )} Jahren `}</b>
                zurück.
              </p>

              <br />

              <Charts.StackedBar
                data={roiChartData}
                titleX="name"
                colors={[
                  { key: "Wert", color: "#a938d3" },
                  { key: "Dividende", color: "#00ffcc" },
                ]}
                showTooltip
                tooltipValues={selectedChartData}
                tooltipFooter={{ title: "Summe", values: selectedChartData }}
              />
            </>
          )}
      </div>
    </>
  );
}

export default ReturnOfInvestment;
